import { render, staticRenderFns } from "./AllStories.vue?vue&type=template&id=67337036&scoped=true"
import script from "./AllStories.vue?vue&type=script&lang=js"
export * from "./AllStories.vue?vue&type=script&lang=js"
import style0 from "./AllStories.vue?vue&type=style&index=0&id=67337036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67337036",
  null
  
)

export default component.exports